export default {
  props: ['id'],
  data() {
    return {
      /** текст комментария */
      message: '',
      /** строка base64 для прикрепленного файла */
      file: '',
      /** Изображение открывающееся в модалке */
      fullImg: '',
      dialog: false,
    };
  },
  computed: {
    /** объект пользователя */
    user() {
      return this.$store.state.user;
    },
    /** сообщения чата в данной продаже */
    messages() {
      return this.$store.state.chat.messages;
    },
    /** непрочитанный чат */
    chat() {
      return this.$store.state.chat.chat;
    },
    /** глобальный флаг загрузчика */
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    /**
     * добавление изображения
     * @param e - эвент
     */
    setImage(e) {
      this.file = (e && e.dataUrl) ? e.dataUrl : '';
    },
    /** начало изменения размера картинки */
    startImageResize() {
      this.$store.dispatch('SetLoading', true);
    },
    /** окончание изменения размера картинки */
    endImageResize() {
      this.$store.dispatch('SetLoading', false);
    },
    /**
     * загрузить картинку для показа
     * @param {string} url - адрес изображения
     */
    SetImage(url) {
      this.fullImg = url;
      this.dialog = true;
    },
    /**
     * устанавливаем цвет бэйджа даты в зависимости от роли и не прочитанности
     * @param {Object} item - объект элемента сообщения в чате
     */
    SetDateColor(item) {
      if (item.admin_id) {
        if (item.readed) {
          return 'primary';
        }
        return '#4db6ac';
      }
      if (item.readed) {
        return '#efefef';
      }
      return '#d0d0d0';
    },
    /** получить список сообщений чата */
    GetMessages() {
      this.$store.dispatch('chat/GetChatMessages', {
        profile_id: this.user.profile_id,
        model_id: +this.$props.id,
        model_class: 'modules\\sales\\common\\models\\Sale',
      });
    },
    /** установить что сообщения данного чата были открыты пользователем */
    ReadMessages() {
      this.$store.dispatch('chat/SetChatMessagesRead', {
        profile_id: this.user.profile_id,
        model_id: +this.$props.id,
        model_class: 'modules\\sales\\common\\models\\Sale',
      });
    },
    /** нажатие на кнопку отправки сообщения в чат */
    Submit() {
      if (this.message || this.file) {
        const payload = {
          profile_id: this.user.profile_id,
          model_id: +this.$props.id,
          model_class: 'modules\\sales\\common\\models\\Sale',
          message: this.message,
          file: this.file,
        };
        this.$store.dispatch('chat/AddChatMessage', payload)
          .then(() => {
            this.message = '';
            this.file = '';
          })
          .then(() => {
            this.GetMessages();
          })
          .catch((error) => {
            this.$store.dispatch('HandleError', error);
          });
      }
    },
  },
  mounted() {
    this.GetMessages();
    this.ReadMessages();
  },
  destroyed() {
    this.$store.dispatch('chat/Clear');
  },
};
